export default __webpack_public_path__ + "static/media/notion_logo.3e5f5758.png";